<template>
  <div class="register__container">
    <header>
      <div class="row m-0">
        <div
          class="col-lg-6 header__left"
        >
          <a href="https://andalin.com/">
            <img src="@/assets/image/logo-andalin-putih.png" alt="" />
          </a>
        </div>
        <div class="col-lg-6 header__right">
          <div class="d-flex justify-content-end">
            <a
              href="tel:02139708070"
              rel="noopener"
              style="text-decoration: none;"
            >
              <img src="@/assets/image/icon/Phone.png" alt="" />
              <span class="pl-2">021 - 3970 8070</span>
            </a>
            <a
              href="mailto:sales@andalin.com"
              rel="noopener"
              style="text-decoration: none;"
            >
              <img src="@/assets/image/icon/Email.png" alt="" />
              <span class="pl-2">sales@andalin.com</span>
            </a>
          </div>
        </div>
      </div>
      <div class="row m-0" style="padding-top: 18px;">
        <div
          class="col-lg-6 header__left"
        ></div>
        <div class="col-lg-6 header__right">
          <div class="d-flex justify-content-end">
            <router-link :to="{ name: 'Signin' }" tag="a">
              Sign In
            </router-link>
            <a href="https://andalin.com/">Back to Andalin.com</a>
          </div>
        </div>
      </div>
    </header>

    <div class="customform">
      <div style="margin-top: 46px; margin-bottom: 46px">
        <div class="customform__tittle">
          <h3 class="m-0">Ship with Andalin Now !</h3>
          <p>Let's Create Your Account Here</p>
        </div>
        <form @submit.prevent="submitData('Submit')" method="post">
          <div class="row m-0 mb-3">
            <div class="input__model1group marginright3" style="width: 48.5%">
              <p class="textdefault">Full Name</p>
              <b-form-input
                name="Fullname"
                v-model="form.userFullname"
                v-validate="'required'"
                placeholder="Enter Your Full Name "
              />
              <div class="fontstyle__errormsg">
                {{ errors.first("Fullname") }}
              </div>
            </div>
            <div class="input__model1group" style="width: 48.5%">
              <p class="textdefault">Company Name</p>
              <b-form-input
                name="Company Name"
                v-model="form.companyName"
                v-validate="'required'"
                placeholder="Enter Company Name"
              />
              <div class="fontstyle__errormsg">
                {{ errors.first("Company Name") }}
              </div>
            </div>
          </div>

          <div class="row m-0 mb-3">
            <div class="input__model1group marginright3" style="width: 48.5%">
              <p class="textdefault">Phone Number</p>
              <div class="row m-0">
                <div class="modifyoptionphone" style="max-width: 145px">
                  <div class="options__multipleselect">
                    <multiselect
                      v-model="selectedDialCodeComp"
                      :allow-empty="false"
                      :options="optionPhone"
                      :custom-label="customPhoneLabel"
                      :show-labels="false"
                      :placeholder="
                        isLoadingDialcode ? 'Loading...' : 'Search...'
                      "
                      name="Phone code"
                      :state="errors.first('Phone code') && false"
                      class="pt-0"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <span
                          >+{{
                            props.option.phonecode
                              ? props.option.phonecode
                              : "00"
                          }}</span
                        >
                        <span> - </span>
                        <span>{{ props.option.code }}</span>
                      </template>
                      <template slot="option" slot-scope="props">
                        <div>
                          <span
                            >+{{
                              props.option.phonecode
                                ? props.option.phonecode
                                : "00"
                            }}</span
                          >
                          <span> - </span>
                          <span>{{ props.option.name }}</span>
                        </div>
                      </template>
                      <span slot="noResult">Oops! No elements found.</span>
                    </multiselect>
                    <img
                      class="options__multipleselect--imgabsolute"
                      style="top: 12px"
                      src="@/assets/image/icon/icon-arrow-gray.png"
                    />
                  </div>
                  <p
                    v-if="errors.has('Phone code')"
                    class="fontstyle__errormsg"
                  >
                    {{ errors.first("Phone code") }}
                  </p>
                </div>
                <div class="col-md pl-2 pr-0" style="width: 69%">
                  <b-form-input
                    type="number"
                    name="Phone Number"
                    v-model="form.userPhone"
                    v-validate="'required'"
                    placeholder="E.g: 8771234xxxxx"
                  />
                  <p class="smallinfo">* Please input your WhatsApp number.</p>
                  <div class="fontstyle__errormsg">
                    {{ errors.first("Phone Number") }}
                  </div>
                </div>
              </div>
            </div>

            <div class="input__model1group" style="width: 48.5%">
              <p class="textdefault">Email Address</p>
              <b-form-input
                name="Email"
                type="email"
                v-model="form.userEmail"
                v-validate="'required|email'"
                placeholder="Work Email Address"
              />
              <div class="fontstyle__errormsg">{{ errors.first("Email") }}</div>
            </div>
          </div>

          <div class="row m-0 mb-3">
            <div class="input__model1group marginright3" style="width: 48.5%">
              <p class="textdefault">Address</p>
              <b-form-textarea
                name="Company Address"
                type="text"
                v-model="form.companyAddress"
                v-validate="'required'"
                placeholder="Company Address"
                rows="5"
                max-rows="6"
                style="max-height: 105px"
              />
              <div
                class="fontstyle__errormsg"
                v-if="errors.first('Company Address')"
              >
                {{ errors.first("Company Address") }}
              </div>
            </div>

            <div style="width: 48.5%" class="dropdowncustom">
              <div class="input__model1group mb-3">
                <p class="textdefault">Job Title</p>
                <b-form-input
                  name="Job Title"
                  v-model="form.userJob"
                  placeholder="Enter Job title"
                  v-validate="'required'"
                />
                <div class="fontstyle__errormsg">
                {{ errors.first("Job Title") }}
              </div>
              </div>
              <div class="dropdowncustom mb-3">
                <p class="fontstyle__default">Company Size</p>
                <div class="options__multipleselect">
                  <multiselect
                    v-model="selectedSize"
                    :options="optionSize"
                    label="name"
                    :placeholder="
                      countriesIsLoading ? 'Loading...' : 'Select CompanySize'
                    "
                    name="Company Size"
                    @input="inputSelectSize"
                    v-validate="'required'"
                    :allow-empty="false"
                    :show-labels="false"
                  >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                  <img
                    class="options__multipleselect--imgabsolute"
                    src="@/assets/image/icon/icon-arrow-gray.png"
                  />
                </div>
                <p v-if="errors.has('Company Size')" class="fontstyle__errormsg">
                  {{ errors.first("Company Size") }}
                </p>
              </div>

              <!-- <div class="dropdowncustom">
                  <p class="fontstyle__default">City</p>
                  <div class="options__multipleselect">
                    <multiselect
                      v-model="selectedCity"
                      :options="optionCity"
                      label="name"
                      :placeholder="isLoadingcityBycountries ? 'Loading City...' : 'Select City'"
                      name="City"
                      :state="errors.first('City') && false"
                      v-validate="'required'"
                      :allow-empty="false"
                      :show-labels="false">
                      <span slot="noResult">Oops! No elements found.</span>
                    </multiselect>
                    <img class="options__multipleselect--imgabsolute"
                          src = "@/assets/image/icon/icon-arrow-gray.png">
                  </div>
                  <p v-if="errors.has('City')" class="fontstyle__errormsg">
                      {{ errors.first('City') }}
                  </p>
                </div> -->
            </div>
          </div>

          <div class="row m-0 mb-3">
            <div class="dropdowncustom marginright3" style="width: 48.5%">
              <p class="fontstyle__default">Country</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectedCountry"
                  :options="optionCountry || []"
                  label="name"
                  placeholder="Select Country"
                  v-validate="'required'"
                  name="Country"
                  @input="inputSelectCountry"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
              <p v-if="errors.has('Country')" class="fontstyle__errormsg">
                {{ errors.first("Country") }}
              </p>
            </div>
            <!-- city ini di hapus nanti -->
            <div class="dropdowncustom" style="width: 48.5%">
              <p class="fontstyle__default">City</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectedCity"
                  :options="optionCity || []"
                  label="name"
                  placeholder="Select City"
                  v-validate="'required'"
                  name="City"
                  @input="inputSelectCity"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
              <p v-if="errors.has('City')" class="fontstyle__errormsg">
                {{ errors.first("City") }}
              </p>
            </div>
            <!-- <div class="dropdowncustom" style="width: 48.5%">
              <p class="fontstyle__default">Province</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectedProvince"
                  :options="optionProvince"
                  label="name"
                  placeholder="Select Province"
                  name="Salesperson"
                  @input="inputSelectProvince"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
            </div> -->
          </div>

          <div class="row m-0 mb-3">
            <!-- <div class="dropdowncustom marginright3" style="width: 48.5%">
              <p class="fontstyle__default">City</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectedCity"
                  :options="optionCity || []"
                  label="name"
                  placeholder="Select City"
                  v-validate="'required'"
                  name="City"
                  @input="inputSelectCity"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
              <p v-if="errors.has('Industry')" class="fontstyle__errormsg">
                {{ errors.first("Industry") }}
              </p>
            </div> -->

            <!-- <div class="dropdowncustom" style="width: 48.5%">
              <p class="fontstyle__default">District</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectedDistrict"
                  :options="optionDistrict || []"
                  label="name"
                  placeholder="Select District"
                  v-validate="'required'"
                  name="Industry"
                  @input="inputSelectDistrict"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
            </div> -->
          </div>

          <div class="row m-0 mb-3">
            <!-- <div class="dropdowncustom marginright3" style="width: 48.5%">
              <p class="fontstyle__default">Sub-District</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectedSubdistrict"
                  :options="optionSubdistrict || []"
                  label="name"
                  placeholder="Select Sub-District"
                  name="Salesperson"
                  @input="inputSelectSubdistrict"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
            </div> -->
            <div class="input__model1group marginright3" style="width: 48.5%;">
              <p class="textdefault">Post Code</p>
              <b-form-input
                name="Post Code"
                type="number"
                v-model="form.postCode"
                v-validate="'required'"
                placeholder="Enter Post Code"
              />
              <div class="fontstyle__errormsg">
                {{ errors.first("Post Code") }}
              </div>
            </div>
            <div class="dropdowncustom" style="width: 48.5%; margin-top: 1px;">
              <p class="fontstyle__default">Salesperson</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="salesPerson"
                  :options="salesList || []"
                  label="name"
                  placeholder="Select Salesperson"
                  name="Salesperson"
                  @input="selectedOption"
                  :allow-empty="false"
                  :show-labels="false"
                  v-validate="'required'"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
              <div class="fontstyle__errormsg">
                {{ errors.first("Salesperson") }}
              </div>
              <div class="fontstyle__errormsg">{{ this.sales_alert_msg }}</div>
            </div>
          </div>

          <div class="row m-0 mb-3">
            <div class="dropdowncustom marginright3" style="width: 48.5%">
              <p class="fontstyle__default">Company Trade Role</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectedTradeRole"
                  :options="modifyGetListTradeRoles || []"
                  label="name"
                  placeholder="Select Your Company Trade Role"
                  v-validate="'required'"
                  name="Company Trade Role"
                  :state="errors.first('Company Trade Role') && false"
                  :allow-empty="false"
                  :show-labels="false"
                  :searchable="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                  <template slot="option" slot-scope="props">
                    <!-- <div v-if="hoverTradeRole === props.option.name" class="option__tooltip">
                      <div><img src="@/assets/image/icon/information-circle-2.svg" alt="info-circle">{{ props.option.desc }}</div>
                    </div> -->
                    <b-tooltip id="tooltip-traderole" show :target="props.option.name" placement="left" custom-class="text-center">
                      {{ props.option.desc }}
                    </b-tooltip>
                    <div class="option__desc" @mouseover="hoverTradeRole = props.option.name">
                      <span class="option__title">{{ props.option.name }}</span>
                      <div>
                        <img :id="props.option.name" src="@/assets/image/icon/information-circle-2.svg" alt="info-circle" class="ml-1">
                      </div>
                    </div>
                  </template>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
              <p
                v-if="errors.has('Company Trade Role')"
                class="fontstyle__errormsg"
              >
                {{ errors.first("Company Trade Role") }}
              </p>
            </div>
            <div
              class="dropdowncustom"
              style="width: 48.5%"
            >
              <p class="fontstyle__default">Company Industry Type</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectedIndustry"
                  :options="getListIndustry || []"
                  label="name"
                  placeholder="Select Company Industry Type"
                  v-validate="'required'"
                  name="Industry"
                  :state="errors.first('Industry') && false"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
              <p v-if="errors.has('Industry')" class="fontstyle__errormsg">
                {{ errors.first("Industry") }}
              </p>
            </div>
            <!-- <div class="dropdowncustom" style="width: 48.5%">
              <p class="fontstyle__default">SalesPerson</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="salesPerson"
                  :options="salesList || []"
                  label="name"
                  placeholder="Select Salesperson"
                  name="Salesperson"
                  @input="selectedOption"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
              <div class="fontstyle__errormsg">
                {{ errors.first("Salesperson") }}
              </div>
              <div class="fontstyle__errormsg">{{ this.sales_alert_msg }}</div>
            </div> -->
          </div>

          <div class="row m-0 mb-3">
            <div class="dropdowncustom marginright3" style="width: 48.5%">
              <p class="fontstyle__default">Yearly Revenue</p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="selectYearlyRevenue"
                  :options="optionYearlyRevenue || []"
                  label="name"
                  placeholder="Select Your Company Yearly Revenue"
                  v-validate="'required'"
                  name="Yearly Reveneu"
                  :state="errors.first('Yearly Reveneu') && false"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-gray.png"
                />
              </div>
              <p
                v-if="errors.has('Yearly Reveneu')"
                class="fontstyle__errormsg"
              >
                {{ errors.first("Yearly Reveneu") }}
              </p>
            </div>
            <div v-if="selectedIndustry.name === 'Others'" class="input__model1group" style="width: 48.5%;">
              <p class="textdefault">Others</p>
              <b-form-input
                name="Industry Others"
                type="text"
                v-model="selectedIndustryOthers"
                v-validate="'required'"
                placeholder="Enter Industry"
              />
              <div class="fontstyle__errormsg">
                {{ errors.first("Industry Others") }}
              </div>
            </div>
          </div>
          <div class="register__pwd">
            <p class="fontstyle__default mb-3 font-weight-bold">
              Account Password
            </p>
            <div class="row m-0 mb-3">
              <div
                class="input__model1group inputpassword marginright3"
                style="width: 48.5%"
              >
                <p class="textdefault">Password</p>
                <b-input-group>
                  <b-form-input
                    name="Password"
                    v-bind:type="publicFieldType1"
                    v-model="form.userPassword"
                    v-validate="'required|verify_password'"
                    placeholder="Enter Password"
                  />
                  <template #append>
                    <div
                      class="toggle-password"
                      @click="publicToggleType('NEW_PWD')"
                    >
                      <img
                        class="passwordvalue__eyesabsolute"
                        src="@/assets/image/icon/icon-eye-slash.png"
                        v-if="publicFieldType1 == 'password'"
                      />
                      <img
                        class="passwordvalue__eyesabsolute open"
                        src="@/assets/image/icon/icon-eye.png"
                        v-if="publicFieldType1 == 'text'"
                      />
                    </div>
                  </template>
                </b-input-group>
                <div
                  v-if="errors.first('Password')"
                  class="fontstyle__errormsg mt-1"
                >
                  {{ errors.first("Password") }}
                </div>
                <div
                  v-else-if="!form.userPassword"
                  style="color: #ffffff; font-size: 12px"
                  class="mt-1"
                >
                  Use 8 or more characters with a mix of small and capital
                  letters, and numbers.
                </div>
              </div>

              <div
                class="input__model1group inputpassword"
                style="width: 48.5%"
              >
                <p class="textdefault">Password Confirmation</p>
                <b-input-group>
                  <b-form-input
                    name="Password confirmation"
                    v-bind:type="publicFieldType2"
                    v-model="form.userPasswordConfirm"
                    v-validate="'required'"
                    placeholder="Enter Password Confirmation"
                  />
                  <template #append>
                    <div
                      class="toggle-password"
                      @click="publicToggleType('CONFIRM_PWD')"
                    >
                      <img
                        class="passwordvalue__eyesabsolute"
                        src="@/assets/image/icon/icon-eye-slash.png"
                        v-if="publicFieldType2 == 'password'"
                      />
                      <img
                        class="passwordvalue__eyesabsolute open"
                        src="@/assets/image/icon/icon-eye.png"
                        v-if="publicFieldType2 == 'text'"
                      />
                    </div>
                  </template>
                </b-input-group>
                <div
                  v-if="errors.has('Password confirmation')"
                  class="fontstyle__errormsg"
                >
                  {{ errors.first("Password confirmation") }}
                </div>
                <div
                  v-else-if="
                    form.userPassword !== form.userPasswordConfirm &&
                      form.userPasswordConfirm
                  "
                  class="text-left fontstyle__errormsg"
                >
                  Passwords do not match.
                </div>
              </div>
            </div>
          </div>

          <div
            class="fontstyle__errormsg text-center"
            v-for="error in error_msg"
            :key="error"
          >
            {{ error }}
          </div>
          <div class="fontstyle__errormsg text-center">
            <p>{{ this.email_available_msg }}</p>
          </div>
          <div class="d-flex justify-content-center mt-4">
            <vue-recaptcha
            :sitekey="tokenEnv"
            ref="recaptcha"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            ></vue-recaptcha>
          </div>
          <div class="text-center my-3">
            <button type="submit" class="button__redcorporite" v-bind:class="{ active: isActive }" :disabled="!isActive">
              <span v-if="isLoading || isLoadingRegister">
                <b-spinner small variant="light" label="Spinning" />
              </span>
              <span v-else>Register Now</span>
            </button>
            <div
              v-if="isError && isError.status"
              class="fontstyle__errormsg text-center pt-2"
            >
              <p>
                Error {{ isError.status }} -
                {{ isError.data ? isError.data.message : isError.statusText }}
              </p>
            </div>
            <p class="my-2 footertext">
              By registering you confirm that you accept the <br />
              <a @click.prevent="terms()" href="#">Terms &amp; Conditions</a>
              and
              <a @click.prevent="policy()" href="#">Privacy Policy</a>
            </p>
          </div>
        </form>
      </div>
    </div>
    <!-- <div class="row m-0 register__header">
      <router-link to="/">
        <img class="register__header--back" src="@/assets/image/icon/arrow-back-full-white.svg">
      </router-link>
      <img src="@/assets/image/icon/avatar.svg" class="register__header--avatar" alt="">
      <div class="register__header--tittle">
        <h6 class="m-0">Welcome !</h6>
        <p>Let's Create Your Account Here</p>
      </div>
    </div>
    <div class="register__content">

    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'
import mixin from '@/mixin'
import ConfigPassword from '@/mixin/getters/config-password'
import { VueRecaptcha } from 'vue-recaptcha'
// import error from 'util'

export default {
  name: 'MainForm',
  props: {
    isError: '',
    isLoadingRegister: Boolean
  },
  components: { VueRecaptcha },
  data () {
    return {
      form: {
        userFullname: '',
        userPhone: '',
        userEmail: this.$route.query.email || '',
        userPassword: '',
        userPasswordConfirm: '',
        companyName: '',
        companyAddress: '',
        userKnoweximku: '',
        industryType: '',
        industryOthers: '',
        companyTradeRole: '',
        industryTypeCode: '',
        industryArea: '',
        industryAreaId: '',
        salesPerson: '',
        countryId: '',
        provinceId: 0,
        cityId: '',
        districtId: 0,
        subdistrictId: 0,
        userJob: '',
        npwp: '',
        companySize: '',
        yearlyRevenue: '&lt;200.000'
      },
      isActive: false,
      token: '',
      showErrorMsg1: 0,
      submited: false,
      email_available_msg: '',
      searchEmail: false,
      error_msg: [],
      sales_alert_msg: '',
      salesPerson: '',
      selectedSize: '',
      selectedIndustry: '',
      selectedIndustryOthers: null,
      selectedTradeRole: '',
      selectedArea: null,
      selectedCountry: null,
      selectedCity: null,
      selectedProvince: '',
      selectedDistrict: '',
      selectedSubdistrict: '',
      selectedDialCodeComp: {
        id: 136,
        code: 'IDN',
        name: 'Indonesia',
        phonecode: 62
      },
      optionSize: [
        { id: '<50 people', name: '<50 people' },
        { id: '50 - 100 people', name: '50 - 100 people' },
        { id: '100 - 500 people', name: '100 - 500 people' },
        { id: '500 - 1000 people', name: '500 - 1000 people' },
        { id: '>1000 people', name: '>1000 people' }
      ],
      optionPhone: [],
      optionCountry: [],
      optionCity: [],
      optionSalesAgs: [],
      optionProvince: [],
      optionDistrict: [],
      optionSubdistrict: [],
      selectYearlyRevenue: null,
      optionYearlyRevenue: [
        { name: '<= IDR 50.000.000.000' },
        { name: '> IDR 50.000.000.000' }
      ],
      tokenEnv: process.env.RECAPTCHA,
      modifyGetListTradeRoles: [],
      hoverTradeRole: '',
      infoHoverTradeRoles: [
        { id: 1, name: 'Manufacturer', desc: 'Produce or assemble half-finished and finished goods' },
        { id: 2, name: 'Distributor', desc: 'Deliver goods to wholesalers or retailers' },
        { id: 3, name: 'Trading', desc: 'Buy, store, and sell products produced by other business' },
        { id: 4, name: 'Logistics', desc: 'Logistic service providers' }
      ]
    }
  },
  mixins: [mixin, ConfigPassword],
  methods: {
    getSalesList () {
      this.$store.dispatch('sales/GET_SALES_LIST')
    },
    getAreaList () {
      this.$store.dispatch('auth/GET_LIST_AREA')
    },
    getIndustryList () {
      this.$store.dispatch('auth/GET_LIST_INDUSTRY')
    },
    getTradeRoleList () {
      this.$store.dispatch('auth/GET_LIST_TRADE_ROLE').then(() => {
        this.getListTradeRole.forEach((el) => {
          this.infoHoverTradeRoles.forEach((el2) => {
            if (el.name === el2.name) {
              this.modifyGetListTradeRoles.push({...el, desc: el2.desc})
            }
          })
        })
      })
    },
    async getDialCode () {
      await this.$store.dispatch('auth/FETCH_DIAL_COUNTRY_CODE')
      await this.modifyDialCode()
    },
    async fetchCountries () {
      await this.$store.dispatch('settingCompany/FETCH_COUNTRIES')
      await this.modifyCountry()
    },
    modifyCountry () {
      return new Promise(resolve => {
        if (this.countryList) {
          this.optionCountry = this.countryList.data
        }
        return resolve()
      })
    },
    modifyProvince () {
      return new Promise(resolve => {
        if (this.getProvincesByCountryId) {
          this.optionProvince = this.getProvincesByCountryId
        }
        return resolve()
      })
    },
    modifyCity () {
      return new Promise(resolve => {
        if (this.cityBycountries) {
          this.optionCity = this.cityBycountries.data // besok diganti by prov
        }
        return resolve()
      })
    },
    modifyDistrict () {
      return new Promise(resolve => {
        if (this.districtByCityId) {
          this.optionDistrict = this.districtByCityId
        }
        return resolve()
      })
    },
    modifySubdistrict () {
      return new Promise(resolve => {
        if (this.subdistrictByDistrictId) {
          this.optionSubdistrict = this.subdistrictByDistrictId
        }
        return resolve()
      })
    },
    modifyDialCode () {
      return new Promise(resolve => {
        if (this.dialcode) {
          this.optionPhone = this.dialcode.data
        }
        return resolve()
      })
    },
    async modifydata () {
      this.datacheck()
      if (this.form.userEmail) {
        const payload = {
          userEmail: this.form.userEmail
        }
        await this.$store.dispatch('auth/EMAIL_CHECK', payload)
      }
      await this.emitToParent()
    },
    emitToParent () {
      return new Promise(resolve => {
        if (this.checkEmail) {
          if (this.checkEmail.email === true) {
            let data = this.form
            this.email_available_msg = ''
            data.userPhone = this.form.userPhone
            data.userPhoneCode = this.selectedDialCodeComp.phonecode
            data.industryType = this.selectedIndustry.name
            data.industryOthers = this.selectedIndustryOthers
            data.companyTradeRole = this.selectedTradeRole.name
            data.industryTypeCode = this.selectedIndustry.code
            data.industryArea = this.selectedCity.name
            data.industryAreaId = this.selectedCity.id.toString()
            data.countryId = this.selectedCountry.id
            data.yearlyRevenue = this.selectYearlyRevenue.name
            data.token = this.token
            this.$emit('activeForm', data)
          } else {
            this.email_available_msg = this.checkEmail.message
            setTimeout(() => (this.email_available_msg = ''), 4000)
          }
        }
        return resolve()
      })
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.modifydata()
        }
      })
    },
    inputSelectPhoneCode () {
      this.form.phoneNumber = `${this.selectedPhoneCode.phonecode}${this.phoneNumber}`
    },
    inputSelectCountry () {
      this.form.countryId = this.selectedCountry.id
    },
    inputSelectProvince () {
      this.form.provinceId = this.selectedProvince.id
    },
    inputSelectCity () {
      this.form.cityId = this.selectedCity.id
    },
    inputSelectDistrict () {
      this.form.districtId = this.selectedDistrict.id
    },
    inputSelectSubdistrict () {
      this.form.subdistrictId = this.selectedSubdistrict.id
    },
    inputSelectSize () {
      this.form.companySize = this.selectedSize.name
    },
    terms: function () {
      this.$eventHub.$emit('dialog-rule-terms')
    },
    policy: function () {
      this.$eventHub.$emit('dialog-rule-policy')
    },
    datacheck () {
      this.error_msg = []
      if (
        this.form.userPassword !== this.form.userPasswordConfirm &&
        this.form.userPasswordConfirm !== ''
      ) {
        this.error_msg.push(
          'Different password confirmation. Please Try again'
        )
      }
    },
    selectedOption () {
      this.form.userKnoweximku = this.salesPerson.username
      this.sales_alert_msg = ''
    },
    removeZeroFirstChar (phoneString) {
      let str = phoneString.toString()
      if (phoneString) {
        if (str.charAt(0) === '+') {
          str = str.substring(1) // remove first character
        }

        if (str.charAt(0) === '0') {
          str = str.substring(1) // remove first character
        } else if (str.charAt(0) === '6' && str.charAt(1) === '2') {
          str = str.substring(2)
        }
      }
      return `${str}`
    },

    customPhoneLabel ({ phonecode, name }) {
      return `${phonecode} – ${name}`
    },

    onCaptchaVerified (recaptchaToken) {
      this.isActive = true
      this.token = recaptchaToken
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
      this.isActive = false
      this.token = ''
    }
  },
  watch: {
    async selectedCountry (data) {
      if (data) {
        await this.$store.dispatch('settingCompany/FETCH_CITY_BY_COUNTRIES', data.id)
        await this.modifyCity()
      }
    },
    async selectedProvince (data) {
      if (data) {
        await this.$store.dispatch('city/FETCH_CITY_BY_PROVINCE', data.id)
      }
      this.modifyCity()
    },
    async selectedCity (data) {
      if (data) {
        await this.$store.dispatch('city/FETCH_DISTRICT_BY_CITY', data.id)
      }
      this.modifyDistrict()
    },
    async selectedDistrict (data) {
      if (data) {
        await this.$store.dispatch(
          'city/FETCH_SUBDISTRICT_BY_DISTRICT',
          data.id
        )
      }
      this.modifySubdistrict()
    },
    salesList (data) {
      if (data) {
        this.optionSalesAgs = data.filter(item => item.name === 'Alibaba')
      }
    },
    selectedTradeRole (data) {
      if (data.name === 'Logistics') {
        this.selectedIndustry = {
          code: '10',
          name: 'Logistic'
        }
      } else if (data.name === 'Trading') {
        this.selectedIndustry = {
          code: '17',
          name: 'Trading and Commerce'
        }
      } else {
        this.selectedIndustry = ''
      }
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/items',
      error: 'auth/error',
      isLoading: 'auth/isLoading',

      checkEmail: 'auth/checkEmail',

      salesList: 'sales/items',
      isLoadingSales: 'sales/isLoading',
      errorSalesList: 'sales/error',

      getListIndustry: 'auth/getListIndustry',
      errorGetListIndustry: 'auth/errorGetListIndustry',
      isLoadingGetListIndustry: 'auth/isLoadingGetListIndustry',

      getListTradeRole: 'auth/getListTradeRole',
      errorGetListTradeRole: 'auth/errorGetListTradeRole',
      isLoadingGetListTradeRole: 'auth/isLoadingGetListTradeRole',

      getListArea: 'auth/getListArea',
      errorGetListArea: 'auth/errorGetListArea',
      isLoadingGetListArea: 'auth/isLoadingGetListArea',

      dialcode: 'auth/dialcode',
      isLoadingDialcode: 'auth/isLoadingDialcode',

      countryList: 'settingCompany/countries',
      isErrorCountries: 'settingCompany/error',
      countriesIsLoading: 'settingCompany/countriesIsLoading',

      cityBycountries: 'settingCompany/cityBycountries',
      isErrcityBycountries: 'settingCompany/isErrcityBycountries',
      isLoadingcityBycountries: 'settingCompany/isLoadingcityBycountries',

      getProvincesByCountryId: 'city/getProvincesByCountryId',
      isLoadingProvincesByCountryId: 'city/isLoadingProvincesByCountryId',
      errorProvincesByCountryId: 'city/errorProvincesByCountryId',

      cityByProvinceId: 'city/getCityByProvinceId',
      isLoadingCityByProvinceId: 'city/isLoadingCityByProvinceId',
      errorCityByProvinceId: 'city/errorCityByProvinceId',

      districtByCityId: 'city/getDistrictByCityId',
      isLoadingDistrictByCityId: 'city/isLoadingDistrictByCityId',
      errorDistrictByCityId: 'city/errorDistrictByCityId',

      subdistrictByDistrictId: 'city/getSubdistrictByDistrictId',
      isLoadingSubdistrictByDistrictId: 'city/isLoadingSubdistrictByDistrictId',
      errorSubdistrictByDistrictId: 'city/errorSubdistrictByDistrictId',

      city: 'city/city',
      // eslint-disable-next-line no-dupe-keys
      error: 'city/error',
      // eslint-disable-next-line no-dupe-keys
      isLoading: 'city/isLoading'
    })
  },
  mounted () {
    this.getSalesList()
    this.getDialCode()
    this.fetchCountries()
    this.getAreaList()
    this.getIndustryList()
    this.getTradeRoleList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/signup/customer/MainForm.vue